import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'

export default {
  install(Vue) {
    const notificationHub = new Vue()
    Vue.prototype.$notificationHub = notificationHub

    let connection = null
    let startedPromise = null
    let manuallyClosed = null

    connection = new HubConnectionBuilder()
      .withUrl(`${process.env.VUE_APP_BACKEND_URL}/notif`)
      .configureLogging(LogLevel.None)
      .build()

    function start() {
      startedPromise = connection.start()
        .catch(err => {
          console.error('Failed to connect with hub', err)
          return new Promise((resolve, reject) => setTimeout(() => start().then(resolve).catch(reject), 5000))
        })
      return startedPromise
    }

    if (!startedPromise) {
      // Forward hub events through the event, so we can listen for them in the Vue components
      connection.on('SendMessage', (message) => {
        notificationHub.$emit('receive-push', message)
      })

      connection.on('ReceiveMessage', (message) => {
        notificationHub.$emit('receive-all', message)
      })

      connection.onclose(() => {
        if (!manuallyClosed) start()
      })

      // Start everything
      manuallyClosed = false
      start()
    }

    Vue.prototype.stopSignalR = () => {
      if (!startedPromise) return

      manuallyClosed = true
      return startedPromise
        .then(() => connection.stop())
        .then(() => { startedPromise = null })
    }

    notificationHub.receiveMessage = (data) => {
      if (!startedPromise) return

      return startedPromise
        .then(() => connection.invoke('receiveMessage', data))
        .catch('project hub' + console.error)
    }
  }
}
